import PropTypes from "prop-types"

export default {
  autoComplete: PropTypes.string,
  disabled: PropTypes.bool,
  max: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  maxLength: PropTypes.number,
  min: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  readOnly: PropTypes.bool,
  required: PropTypes.bool
}
